import { Text as TextNative } from 'components/primitives/cross-platform';

export const Text = TextNative;
